module.exports = __webpack_public_path__ + "media/images/icon__unlocked-6ec385663cb961e943c1683da0a56c0c.png";